
import React, { Component, Fragment, useEffect, useState, useContext } from "react";
import { SessionContext } from "../../../context/SessionProvider";



import BiCheckBox from '../../uic/controls/BiCheckBox';
import BiTextBox from '../../uic/controls/BiTextBox';
import BiLabel from '../../uic/controls/BiLabel';

import BiFormTable from '../../uic/formTable/BiFormTable';
import BiFormRow from '../../uic/formTable/BiFormRow';
import BiFormCell from '../../uic/formTable/BiFormCell';
import BiFormSection from '../../uic/formTable/BiFormSection';
import BiCheckBoxList from "../../uic/controls/BiCheckBoxList";
import BiTextArea from "../../uic/controls/BiTextArea";
import BiButton from "../../uic/controls/BiButton";
import { httpGet } from "../../helpers/httpHelper";

import authService from '../../api-authorization/AuthorizeService'
const IzpisiObrazca = ({
    obrazec,
    obrazecDetail
}) => {
    const { sessionReady, sessionData, setLoading, toastError, toastOK, setHelpMainKey } = useContext(SessionContext)

    const [izpisi, setIzpisi] = useState();

    useEffect(() => {

        setLoading(true);

        httpGet(
            "api/report/GetPReportItems",
            {
                PTipObrazca: obrazec.pIdTipObrazca,
                Status: obrazec.pIdStatus
            },
            (ret) => {
                setIzpisi(ret);
                
                setLoading(false);
            },
            authService);


    }, [obrazec])


    const getIzpis = (item) => {

        console.log(item, obrazec);
        setLoading(true);
        const sss = authService.getAccessToken().then(token => {

            const requestOptions = {
                method: 'GET',
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            const params = {

                PIdIzpis: item.pIdIzpis,
                PIdObrazca: obrazec.pIdObrazca
            };

            var fileName = "";

            const url = "api/report/GetPReport" + "?" + (new URLSearchParams(params)).toString();
            fetch(url, requestOptions)
                .then(response => {

                    const contentDisposition = response.headers.get('Content-Disposition');
                    console.log(contentDisposition);
                    if (contentDisposition) {
                        const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        const matches = fileNameRegex.exec(contentDisposition);
                        if (matches != null && matches[1]) {
                            fileName = matches[1].replace(/['"]/g, '');
                            
                        }
                    }
                    return response.blob();
                }).then(ret => {

                    const file = new Blob([ret], { type: ret.type });
                    const fileURL = URL.createObjectURL(file);

                    var anchor = document.createElement("a");
                    anchor.download = fileName;
                    anchor.href = fileURL;
                    anchor.click();

                    setLoading(false);
                });
        });
    }

    return (
        <Fragment>

            {izpisi && izpisi.map((item, index) =>

                <BiButton key={"izpis_" + index + "_" + item.pIdIzpis} className="btn-outline-secondary" margin="4px" icon={item.ikona} onClick={() => getIzpis(item) }  >{item.naziv}</BiButton>
            )}
           
        </Fragment>
    );
}

export default IzpisiObrazca;